import { axios } from "@cores/axiosWrapper";

/**
 * S3 오브젝트의 presigned URL 을 발급받는다.
 *
 * NOTE: 원래 modules/propertyPanel.js 에 있었으나, 그 모듈이 @components/property-panel(대형 UI 트리)을
 *       정적으로 import 하고 있어 API 하나를 쓰려는 쪽까지 UI 그래프를 끌어오게 된다. API 레이어로 옮겼다.
 *
 * @param {string} apiEndpoint
 * @param {string} stageVersion
 * @param {string} projectId
 * @param {{bucket: string, fileName: string}} data
 * @returns {Promise<{data: {presignedUrl: string}}>}
 */
export async function presignObjectAPI(apiEndpoint, stageVersion, projectId, data) {
    let headers = { projectId };
    let requestBody = {
        ...data,
    };
    requestBody = Buffer.from(encodeURIComponent(JSON.stringify(requestBody))).toString("base64");
    headers = {
        ...headers,
        "x-mzc-content-encoding": "base64",
    };
    return await axios.post(`${apiEndpoint}/aws/s3/objects:presign`, requestBody, {
        headers,
    });
}
